module.exports = __webpack_public_path__ + "static/media/logoCompanyWhite.a3f607fd.svg";